// Filename - components/EvolveMeHero.js

import React, { Fragment }  from "react";
import { Row, Col} from "react-bootstrap";


export default function EvolveMeHero (){


    return (
      <Fragment>
         <Row className="square border-top border-start border-end border-success">
               <Col className="col-12 col-md-3 ps-0 pt-3">
                  <img
                     src="images/partners/Fruit-Strawberry.png"
                     height="90"
                     width = "auto"
                     className="align-top"
                     alt="Snail"
                  />
               </Col>
               <Col className="col-12 col-md-6">
                  <img
                     src="images/partners/EvolveMeAndMA.png"
                     height="100"
                     width = "auto"
                     className="align-top"
                     alt="EvolveMe logo"
                  />
               </Col>
               <Col className="col-12 col-md-3 pe-0 pt-3 d-flex justify-content-end">
                  <img
                     src="images/partners/Snail.png"
                     height="90"
                     width = "auto"
                     
                     alt="Snail"
                  />
               </Col>
            </Row> 
            <Row className="square border-start border-end border-bottom border-success mb-5">
               <Col className="col-12 text-center pt-5 pb-3 ps-5 pe-5">
                  <p> EvolveMe has partnered with MindAntix to kickstart your creative journey to becoming innovators and changemakers of tomorrow. </p>
                  <p> If you are new to MindAntix, just register and get started on your <em> Invent In An Hour</em> task.</p>
               </Col>
         
            </Row>
      </Fragment>
    )

}
